import { useRouter } from 'next/router';
import {
  Select, MenuItem, Checkbox, FormControl, InputLabel,
} from '@mui/material';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import { castArray } from 'lodash';
import { POST_TYPE_OBJECTS } from 'lib/constants';

interface Props {
  fileTypes?: string[];
  disabled?: boolean;
  includeStories?: boolean;
}

export const FileTypeFilter = ({
  fileTypes = [], disabled = false, includeStories = false,
}: Props) => {
  const router = useRouter();
  const allFileTypes = includeStories
    ? Object.keys(POST_TYPE_OBJECTS)
    : Object.keys(POST_TYPE_OBJECTS).filter((key) => !POST_TYPE_OBJECTS[key].teamOnly);
  const values = fileTypes.length === 0 ? allFileTypes : castArray(fileTypes);

  const onChange = (n: string[]) => {
    updateRouterQuery(router, { fileType: n });
  };

  const onClose = (): void => {
    // This is a small hack so that the Select blurs when the select menu is closed.
    // See https://stackoverflow.com/questions/65411927/blur-material-ui-select-component-on-the-onchange-event
    setTimeout(() => {
      (document?.activeElement as HTMLInputElement)?.blur();
    }, 0);
  };

  return (
    <FormControl className="w-full" size="small" disabled={disabled}>
      <InputLabel id="file-type-select-label">File Types</InputLabel>
      <Select
        className="w-full"
        label="file types"
        labelId="file-type-select-label"
        id="file-type-select"
        multiple
        onClose={onClose}
        onChange={(e) => onChange(e.target.value as string[])}
        renderValue={(selected) => selected.map((s) => POST_TYPE_OBJECTS[s]?.title).join(', ')}
        value={values}
      >
        {allFileTypes.map(
          (key: string) => (
            <MenuItem key={key} value={key}>
              <div className="flex flex-1 items-center justify-between group">
                <div>

                  <Checkbox size="small" checked={fileTypes.length === 0 || fileTypes.includes(key)} />
                  {POST_TYPE_OBJECTS[key].title}
                </div>
                <div className="md:hidden group-hover:block">
                  <button
                    type="button"
                    className="btn-primary-xs"
                    onClick={(e) => {
                      onChange([key]);
                      e.stopPropagation();
                    }}
                  >
                    Only
                  </button>
                </div>
              </div>
            </MenuItem>
          ),
        )}
        <div className="text-right pr-2 mt-2">
          <button
            type="button"
            className="btn-secondary-outlined-xs"
            onClick={() => onChange([])}
            disabled={values.length === allFileTypes.length}
          >
            Clear
          </button>
        </div>
      </Select>
    </FormControl>
  );
};
